import { useContext } from "react";
import { AppContext } from "../App";
import { MdMenu } from "react-icons/md";
import { IoMdCall } from "react-icons/io";
import { FaTruckFast } from "react-icons/fa6";
import logo_icon from "../assets/logo_icon.png";

export default function TopBar() {
  const appContext = useContext(AppContext);

  function goTo(item) {
    appContext.navTo({ item });
  }

  const navItems = [
    { label: "Home", key: "home" },
    { label: "About Us", key: "about_us" },
    { label: "Services", key: "services" },
    { label: "Gallery", key: "gallery" },
    { label: "Projects", key: "projects" },
    { label: "Staff", key: "staff" },
  ];

  return (
    <div className="TopBar topbar-modern">
      <div className="body topbar-modern-body">
        <div className="container d-flex align-items-center justify-content-between h-100">
          <div className="topbar-brand d-flex align-items-center">
            <button className="topbar-brand-mark" onClick={() => goTo("home")}>
              <img src={logo_icon} width={100} />
            </button>
          </div>

          <div className="topbar-modern-nav mDesktopOnly">
            {navItems.map((item) => (
              <button
                key={item.key}
                className={`topbar-modern-link ${
                  appContext.navItem === item.key ? "active" : ""
                }`}
                onClick={() => goTo(item.key)}
              >
                {item.label}
              </button>
            ))}

          </div>

          <div className="topbar-mobile-actions mMobileOnly d-flex align-items-center">
            <button
              className="btn btn-sm btn-secondary btn-rounded me-2"
              onClick={() => goTo("contact_us")}
            >
              <IoMdCall size={20} className="me-1" />
              Contact Us
            </button>

            <button
              className="topbar-modern-menu-btn mMobileOnly"
              onClick={appContext.openSideBar}
              aria-label="Open menu"
            >
              <MdMenu size={30} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
